/**
 * Central language definitions for UI, reporting APIs, and speech/dictation.
 *
 * - UI_* — i18n / navbar (`medilis_ui_language`, codes: en, he, …)
 * - DICTATION_* — STT / mic (`medilis_dictation_language`, locales: en-US, …)
 */

/** Matches i18n `supportedLngs` in config.js. */
export const UI_LANGUAGES = [
  { value: "en", label: "English" },
  { value: "fr", label: "French" },
  { value: "he", label: "Hebrew" },
  { value: "ar", label: "Arabic" },
  { value: "es", label: "Spanish" },
];

const UI_LABEL_BY_CODE = Object.fromEntries(
  UI_LANGUAGES.map(({ value, label }) => [value, label]),
);

/** Display label for a UI language code (reporting panels, etc.). */
export function getUiLanguageLabel(code) {
  return UI_LABEL_BY_CODE[code] ?? UI_LABEL_BY_CODE.en;
}

/** Speech / dictation locales for LanguageDropdown and CRE mirror. */
export const DICTATION_LANGUAGES = [
  { value: "en-US", label: "English (US)" },
  { value: "fr-FR", label: "French (France)" },
  { value: "es-ES", label: "Spanish (Spain)" },
  { value: "es-MX", label: "Spanish (Mexico)" },
  { value: "he-IL", label: "Hebrew (Israel)" },
  { value: "ar-SA", label: "Arabic (Saudi Arabia)" },
  { value: "ar-EG", label: "Arabic (Egypt)" },
  { value: "ar-AE", label: "Arabic (UAE)" },
];

/** Compact labels for mic popovers (space-constrained UI). */
const DICTATION_SHORT_LABEL_BY_CODE = {
  "en-US": "English",
  "fr-FR": "French",
  "es-ES": "Spanish",
  "es-MX": "Spanish (MX)",
  "he-IL": "Hebrew",
  "ar-SA": "Arabic",
  "ar-EG": "Arabic (EG)",
  "ar-AE": "Arabic (AE)",
};

export function getDictationLanguageLabel(dictationLang) {
  if (!dictationLang) return "English";
  return DICTATION_SHORT_LABEL_BY_CODE[dictationLang] ?? dictationLang;
}

const VOICE_TEST_DICTATION_CODES = ["en-US", "es-ES", "fr-FR", "he-IL", "ar-SA"];

/** Voice command test page — filter dropdown (subset of dictation locales). */
export const VOICE_TEST_LANGUAGE_FILTER_OPTIONS = [
  { value: "", label: "All languages" },
  ...VOICE_TEST_DICTATION_CODES.map((value) => ({
    value,
    label: `${getDictationLanguageLabel(value)} (${value})`,
  })),
];
